export default "__VITE_ASSET__CBQ7I5oo__"